module.exports = __webpack_public_path__ + "img/1.c393d5bd.png";